import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { appActions } from 'STORE/appSlice';

export default function useSnackbar() {
  const dispatch = useDispatch();
  return useMemo(
    () =>
      /**
       * @param {{message: string, duration: number, type: ('info' | 'danger' | 'success' | 'warning')}} args
       */
      (args) =>
        dispatch(appActions.showSnackbar(args)),
    []
  );
}
